<template>
  <v-dialog v-model="errorDialog" persistent>
    <div class="error-wrapper custom-card-shadow bg-white">
      <div class="p-15 center">
        <img src="../../../assets/decline-general.svg" class="m-t-5" />
        <h1 class="font-lg m-t-10 m-b-10">{{ title }}</h1>
        <p class="font-nm">{{ message }}</p>
        <p class="m-t-10" v-if="toPage">
          <router-link :to="toPage" class="gray-d-text font-sm underline">Dismiss</router-link>
        </p>
        <p class="m-t-10" v-else>
          <span class="gray-d-text font-sm underline cursor-pointer" @click="errorDialog = false">Dismiss</span>
        </p>
      </div>
    </div>
  </v-dialog>
</template>

<script>
  export default {
    name: "ErrorDialog",
    data() {
      return {
        errorDialog: false
      }
    },
    methods: {
      setOpen (state) {
        this.errorDialog = state
      }
    },
    props: {
      toPage: String,
      open: Boolean,
      title: String,
      message: String
    }
  }
</script>

<style scoped>
  .error-wrapper {
    max-width: 70%;
    width: 70%;
    margin: 0 auto;
  }
  .error-wrapper img {
    width: 80px;
  }
  .cursor-pointer {
    cursor: pointer;
  }
  @media only screen and (min-width: 768px) {
    .error-wrapper {
      width: 25%;
    }
    .error-wrapper img {
      width: 110px;
    }
    .font-lg {
      font-size: 20px;
    }
    .font-nm {
      font-size: 16px !important;
    }
    .font-sm {
      font-size: 14px;
    }
  }
</style>
